function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ComponentType, Ref, PureComponent, createRef } from 'react';
import { getDisplayName } from '../../lib/getDisplayName';
import { mergeAllRefs } from '../../lib/mergeRefs';
export const withAutoFocus = WrappedComponent => class WithAutoFocus extends PureComponent {
  static displayName = `withAutoFocus(${getDisplayName(WrappedComponent)})`;
  controlRef = /*#__PURE__*/createRef();
  componentDidUpdate(prevProps) {
    if (this.controlRef.current !== null && this.props.focused !== prevProps.focused) {
      if (this.props.focused) {
        this.controlRef.current.focus();
      } else {
        this.controlRef.current.blur();
      }
    }
  }
  render() {
    const {
      controlRef = null
    } = this.props;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
      controlRef: mergeAllRefs(this.controlRef, controlRef)
    }));
  }
};